export function resolveComposerMetadata(
  composerMetadata: Record<string, string> | null | undefined,
  isReply: boolean,
): Record<string, string> | undefined {
  if (isReply || composerMetadata == null) return undefined;
  return composerMetadata;
}
